<div *ngIf="opportunity$ | async as opportunity">
  <ng-container *ngIf="userPipelines$ | async as pipelines">
    <ng-container *ngIf="pipelines.length > 1">
      <glxy-form-field appearance="outline">
        <glxy-label>
          {{ 'FRONTEND.SALES_OPPORTUNITIES.PIPELINE' | translate }}
        </glxy-label>
        <mat-select
          [value]="selectedPipeline$ | async"
          placeholder="{{ 'FRONTEND.SALES_OPPORTUNITIES.PIPELINE' | translate | lowercase }}"
          (selectionChange)="pipelineSelectionChange($event.value, opportunity)"
        >
          <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline">
            {{ pipeline.name }}
          </mat-option>
        </mat-select>
      </glxy-form-field>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="selectedPipeline$ | async as pipeline">
    <glxy-form-field appearance="outline">
      <glxy-label>
        {{ 'FRONTEND.SALES_OPPORTUNITIES.STAGE' | translate }}
      </glxy-label>
      <glxy-error *ngIf="Boolean(selectedStage$ | async) === false">
        {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ERRORS.PIPELINE_STAGE_SELECTION' | translate }}
      </glxy-error>
      <mat-select
        [value]="selectedStage$ | async"
        placeholder="{{ 'FRONTEND.SALES_OPPORTUNITIES.STAGE' | translate | lowercase }}"
        (selectionChange)="stageSelectionChange($event.value, opportunity)"
      >
        <mat-option *ngFor="let stage of pipeline.stages" [value]="stage">{{ stage.name }}</mat-option>
      </mat-select>
    </glxy-form-field>
  </ng-container>
</div>
